var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9167 1H4.08333C2.51853 1 1.25 2.26853 1.25 3.83333V15.1667C1.25 16.7315 2.51853 18 4.08333 18H23.9167C25.4815 18 26.75 16.7315 26.75 15.1667V3.83333C26.75 2.26853 25.4815 1 23.9167 1Z",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4295 10.8321C16.4295 9.50157 15.26 8.4191 13.8224 8.4191C13.2015 8.4191 12.7679 8.14221 12.7679 7.74572C12.7679 7.35894 13.0795 7.04426 13.4624 7.04426C13.8484 7.04426 14.3512 7.08634 15.154 7.39854C15.5873 7.5671 16.0751 7.35237 16.2436 6.91913C16.4121 6.48585 16.1974 5.99802 15.7642 5.82955C15.3463 5.66701 14.982 5.56045 14.6618 5.49029V4.84173C14.6618 4.37684 14.285 4 13.8201 4C13.3552 4 12.9784 4.37684 12.9784 4.84173V5.41058C11.8985 5.63545 11.0845 6.59696 11.0845 7.74572C11.0845 8.42104 11.38 9.03492 11.9168 9.47422C12.4189 9.88528 13.0779 10.1026 13.8224 10.1026C14.323 10.1026 14.746 10.4367 14.746 10.8321C14.746 11.2057 14.3985 11.5335 14.0024 11.5335C13.6934 11.5335 12.918 11.4202 12.1529 11.1161C11.7209 10.9444 11.2314 11.1554 11.0597 11.5873C10.888 12.0194 11.0991 12.5088 11.531 12.6805C12.0185 12.8743 12.527 13.0125 12.9783 13.1001V13.5958C12.9783 14.0607 13.3551 14.4375 13.82 14.4375C14.2849 14.4375 14.6617 14.0607 14.6617 13.5958V13.1257C15.0466 13.0174 15.4023 12.815 15.6987 12.5294C16.17 12.0753 16.4295 11.4725 16.4295 10.8321Z",
    fill: "#FF6019"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.5H22.5142",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5H5.51417",
    stroke: "#6921C4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashNew);
export default __webpack_public_path__ + "static/media/CashNew.8ab5d5d3.svg";
export { ForwardRef as ReactComponent };